import { ApiResponseType, BillingCurrentPlanType, BillingSubscriptionType, Maybe } from '@/types/sharedTypes';
import { authApiService } from '../../authApiService';
import { OrganizationStatusType } from '@/bundle/_Opco/types/types';
import { OrganizationUserStatusType, TokenUserRoleType } from '@/const/user';
import { SignUpStepType, SubscriptionPlanType } from '@/const/shared';

export type BillingProfileType = {
  current_plan: BillingCurrentPlanType;
  subscription: BillingSubscriptionType;
  extra_views_available: number;
  monthly_views_available: number;
  extra_views_bought: number;
};

export type OrganizationDetailsUserType = {
  id: string;
  name: string;
  status: OrganizationStatusType;
  is_kyc_allowed: boolean;
  is_msa_confirmed: boolean;
  is_api_keys_allowed: boolean;
  billing_profile?: Maybe<BillingProfileType>;
  subscription_plan_type: SubscriptionPlanType;
};

type OrganizationUserType = {
  id: string;
  role: 'org_admin' | 'master_admin';
  status: OrganizationUserStatusType;
  organization: Maybe<OrganizationDetailsUserType>;
};

type OpcoUserType = {
  id: string;
  operation_company: { id: string; name: string };
  role: 'admin';
};

type RecipientUserType = {
  id: string;
  status: 'active';
  recipient: {
    id: string;
    status: 'active';
  };
};

type DepositorUserType = { id: string };

type ExecutorUserType = { id: string };

export type SelfUserDetailsType = {
  id: string;
  created_by: {
    id: string;
    email: string;
  };
  active_roles: TokenUserRoleType;
  date_created: string;
  date_modified: string;
  username: string;
  first_name: string;
  last_name: string;
  middle_name: string;
  language: string;
  is_verified: boolean;
  signup_step: SignUpStepType;
  email: string;
  mobile_phone: string;
  status: string;
  last_time_login: string;
  organization_user: Maybe<OrganizationUserType>;
  opco_user: Maybe<OpcoUserType>;
  recipient_user: Maybe<RecipientUserType>;
  depositor: Maybe<DepositorUserType>;
  executor: Maybe<ExecutorUserType>;
};

export const getSelfUserDetailsApi = async (): Promise<ApiResponseType<SelfUserDetailsType>> => {
  const uri = `/users/me/`;

  return authApiService.GET(uri);
};
